import request from '../request';

export const getTripStatuses = () =>
  request.get('tripstatuses').then((res) => res);
